import React from 'react';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import styles from './ContactInformation.module.css';

const ContactInformation: React.FC = () => {
  const contactDetails = [
    { 
      icon: <MdEmail size={20} />,
      label: 'Email',
      value: 'michaelfarrellyjpn@gmail.com',
      href: 'mailto:michaelfarrellyjpn@gmail.com'
    },
    { 
      icon: <BsLinkedin size={20} />,
      label: 'LinkedIn',
      value: 'linkedin.com/in/mike-farrelly',
      href: 'https://linkedin.com/in/mike-farrelly'
    },
    { 
      icon: <BsGithub size={20} />,
      label: 'GitHub',
      value: 'github.com/MikeMikerson',
      href: 'https://github.com/MikeMikerson'
    },
    { 
      icon: <MdLocationOn size={20} />,
      label: 'Location',
      value: 'Tokyo, Japan',
      href: null
    },
  ];

  return (
    <div className={styles.contactInformation}>
      <h2>Contact Information</h2>
      <div className={styles.contactGrid}>
        {contactDetails.map((contact, index) => (
          <div key={index} className={styles.contactCard}>
            <div className={styles.contactHeader}>
              <span className={styles.contactIcon} aria-hidden="true">
                {contact.icon}
              </span>
              <h3>{contact.label}</h3>
            </div>
            <div className={styles.contactDetail}>
              {contact.href ? (
                <a 
                  href={contact.href}
                  className={styles.contactLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {contact.value}
                </a>
              ) : (
                <span>{contact.value}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInformation;